import $ from "jquery";
import ScrollReveal from 'scrollreveal';
$(document).ready(() => {
    if ($("#timeline").length) {
        window.sr = ScrollReveal(), sr.reveal(".sReveal"), sr.reveal(".sReveal-rightdelaypourcent", {
            origin: "left",
            delay: "500",
            easing: "ease-in-out",
            distance: "200px",
            viewFactor: .8
        }), sr.reveal(".sReveal-right", {
            origin: "right",
            distance: "20px",
            viewFactor: .8
        }), sr.reveal(".sReveal-left", {
            origin: "left",
            distance: "20px",
            ng: "ease-in-out",
            viewFactor: .8
        }), sr.reveal(".sReveal-left-far", {
            origin: "left",
            distance: "2000px",
            viewFactor: .8
        }), sr.reveal(".sReveal-rightdelay20", {
            origin: "bottom",
            delay: "1000",
            easing: "ease-in-out",
            distance: "200px",
            viewFactor: .8
        }), sr.reveal(".sReveal-bottom", {
            origin: "bottom",
            easing: "ease-in-out",
            distance: "50px",
            viewFactor: .8
        }), sr.reveal(".sReveal-top", {
            origin: "top",
            easing: "ease-in-out",
            distance: "50px",
            viewFactor: .8
        }), sr.reveal(".sReveal-motion", {
            origin: "top",
            easing: "ease-in-out",
            distance: "0px",
            delay: "500",
            viewFactor: .8
        });
        // var i = {},
        //     a = {
        //         container: null,
        //         renderer: "svg",
        //         loop: !1,
        //         autoplay: !1,
        //         autoloadSegments: !0,
        //         rendererSettings: {
        //             progressiveLoad: !1
        //         },
        //         path: null
        //     };
        // $(".motion").each(function (t) {
        //     var e = $(this),
        //         n = e.data("path");
        //     a.path = "/motion/" + n + "/data.json", a.container = document.getElementById(e.attr("id")), i[n] = bodymovin.loadAnimation(a)
        // });
        // var n = {};
        // sr.reveal(".motion", {
        //     viewFactor: 1.2,
        //     delay: 400,
        //     reset: !0,
        //     beforeReveal: function (t) {
        //         void 0 !== n[$(t).data("path")] && i[$(t).data("path")].goToAndStop(1)
        //     },
        //     afterReveal: function (t) {
        //         n[$(t).data("path")] = !0, i[$(t).data("path")].play()
        //     }
        // })
    }
});
